<template>
  <div v-show="!selection.isDragging.value" class="bk">
    <div
      v-for="area in areas"
      :key="area.key"
      class="bk-field-area"
      :style="area.style"
      :class="{ 'bk-is-active': area.key === selection.activeFieldKey.value }"
      @click="eventBus.emit('setActiveFieldKey', area.key)"
    >
      <div>
        <span>{{ area.label }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, useBlokkli } from "#imports";
const { eventBus, selection } = useBlokkli();
const areas = ref([]);
</script>
